import { createFileRoute, redirect } from "@tanstack/react-router";

/** The old compliance root; see `$org.regulation.$` for the rest of the tree. */
export const Route = createFileRoute("/$org/regulation/")({
  beforeLoad: ({ params, location }) => {
    throw redirect({
      to: "/$org/compliance",
      params: { org: params.org },
      search: location.search,
      replace: true,
    });
  },
});
